import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './VehicleSearch.actions';
import reducer, { initialState, IState } from './VehicleSearch.reducer';

export const VehicleStateContext = createContext<IState>(initialState);
export const VehicleDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useVSDispatch = () => useContext(VehicleDispatchContext);

interface IVehicleSearchStateProvider {
  children: React.ReactNode;
}

export const useVRContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(VehicleStateContext, selector);

const VehicleSearchStateProvider = ({ children }: IVehicleSearchStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <VehicleStateContext.Provider value={state}>
      <VehicleDispatchContext.Provider value={dispatch} >
        {children}
      </VehicleDispatchContext.Provider>
    </VehicleStateContext.Provider>
  );
};

export default VehicleSearchStateProvider;
